export default "__VITE_ASSET__4764b18b__"